import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "bede2e77-c2b1-4372-b58b-72dd4da8c58d",
  publicId: "19",
  name: "Floors and ceilings",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, principle02, task01, task02, task03],
};

export default lesson;
